import { render, staticRenderFns } from "./familyForm.vue?vue&type=template&id=c7c06914&scoped=true&"
import script from "./familyForm.vue?vue&type=script&lang=js&"
export * from "./familyForm.vue?vue&type=script&lang=js&"
import style0 from "./familyForm.vue?vue&type=style&index=0&id=c7c06914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c06914",
  null
  
)

export default component.exports